import axios from "axios";
import Cookies from "js-cookie";

export default function () {
    const hanseContainers = document.querySelectorAll(".hanse-redirect-to-url");
    if (!hanseContainers || document.body.classList.contains('staging')) {
        return;
    }
    hanseContainers.forEach($hanseContainer => {
        const currentURL = window.location.href;
        let redirectURL = "";
        if (currentURL.includes("redirect=")){
            redirectURL = currentURL.slice(currentURL.indexOf('redirect=') + 9);
        } else{
            redirectURL = $hanseContainer.dataset.url;
        }

        if (!redirectURL) {
            return;
        }
        const apiURL = "/partner/api/public/vermittler/publicinfos"
        const config = {
            headers: {
                'XSRF-TOKEN': Cookies.get('XSRF-TOKEN'),
                merkur_user_session_id: Cookies.get('merkur_user_session_id'),
            },
        };

        axios.get(apiURL, config)
            .then(response => {
                if (response.status === 200
                    && response.data !== undefined && response.data !== null
                    && response.data.hardfacts !== undefined && response.data.hardfacts !== null) {

                    const facts = response.data.hardfacts;

                    if (redirectURL.includes("?")) {
                        redirectURL += "&";
                    } else {
                        redirectURL += "?";
                    }

                    if (facts.vermittlernummer !== undefined && facts.vermittlernummer !== null) {
                        redirectURL += 'agent=' + facts.vermittlernummer;
                        if (facts.name !== undefined && facts.name !== null) {
                            redirectURL += ',' + facts.name;
                        }
                    } else if (facts.name !== undefined && facts.name !== null) {
                        redirectURL += 'agent=' + facts.name;
                    }
                }

                location.href = redirectURL;
            })
            .catch(e => {
                console.error(e);
                location.href = redirectURL;
            })
    });


}
